import {updateCropsDetailsCall} from './digidiary.service';
import {handleAlert} from './sagaHelper';
import {getCustomerId} from './selectors';

import {DD_UPDATE_CROP_DETAILS, PUSH_DIGIDIARY_VIEW} from '../actions';

import {call, put, select, takeEvery} from 'redux-saga/effects';

export function* updateCropDetails({data}) {
  const customerId = yield select(getCustomerId);
  const response = yield updateCropsDetailsCall(customerId, data);
  if (response.statusCode && response.statusCode === 200) {
    let newView = 'myFarm';
    yield put({type: PUSH_DIGIDIARY_VIEW, newView});
    yield call(handleAlert, {variant: 'success', type: 'updateCropSuccess'});
  } else {
    yield call(handleAlert, {variant: 'error', type: 'alertError'});
  }
}

export function* updateCropDetailsWatcher() {
  yield takeEvery(DD_UPDATE_CROP_DETAILS, updateCropDetails);
}
